import React from "react";

const logoStyle = `
  .bs-ring  { animation: bsPulse 2s ease-out infinite; transform-origin: 32px 34px; }
  .bs-ring2 { animation: bsPulse 2s ease-out 0.7s infinite; transform-origin: 32px 34px; }
  @keyframes bsPulse {
    0%   { transform: scale(0.8); opacity: 0.8; }
    100% { transform: scale(1.6); opacity: 0; }
  }
  .bs-eye  { animation: bsBlink 3.5s ease-in-out infinite; transform-origin: 22px 31px; }
  .bs-eye2 { animation: bsBlink 3.5s ease-in-out 0.1s infinite; transform-origin: 42px 31px; }
  @keyframes bsBlink {
    0%,90%,100% { transform: scaleY(1); }
    95% { transform: scaleY(0.1); }
  }
  .bs-dot { animation: bsDotPulse 1.4s ease-in-out infinite; transform-origin: 32px 6px; }
  @keyframes bsDotPulse {
    0%,100% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.6); opacity: 0.5; }
  }
`;

export default function Logo({ size = 32, showText = true }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: showText ? 10 : 0 }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        style={{ flexShrink: 0 }}
      >
        <defs>
          <style>{logoStyle}</style>
        </defs>

        <circle className="bs-ring"  cx="32" cy="34" r="28" fill="none" stroke="#25d366" strokeWidth="1.2" opacity="0.6"/>
        <circle className="bs-ring2" cx="32" cy="34" r="28" fill="none" stroke="#25d366" strokeWidth="0.8" opacity="0.4"/>

        <rect x="12" y="18" width="40" height="34" rx="8" fill="#111111" stroke="#25d366" strokeWidth="1.8"/>

        <line x1="32" y1="18" x2="32" y2="8" stroke="#25d366" strokeWidth="2" strokeLinecap="round"/>
        <circle className="bs-dot" cx="32" cy="6" r="3" fill="#25d366"/>

        <rect className="bs-eye"  x="17" y="26" width="10" height="10" rx="3" fill="#25d366"/>
        <rect className="bs-eye2" x="37" y="26" width="10" height="10" rx="3" fill="#25d366"/>
        <circle cx="22" cy="30" r="2.5" fill="#111" opacity="0.7"/>
        <circle cx="42" cy="30" r="2.5" fill="#111" opacity="0.7"/>

        <path d="M20 42 Q32 50 44 42" fill="none" stroke="#25d366" strokeWidth="2" strokeLinecap="round"/>
      </svg>

      {showText && (
        <span style={{
          fontSize: size * 0.56,
          fontWeight: 700,
          color: "#ffffff",
          letterSpacing: "-0.3px",
          fontFamily: "Georgia, serif",
          lineHeight: 1,
        }}>
          Bot<span style={{ color: "#25d366" }}>Saathi</span>
        </span>
      )}
    </div>
  );
}